import {Box, Col, ColRow, Flex, Grid} from '@indoqa/style-system'
import {useQueryParam} from '@oegbv/ui-shared'
import * as React from 'react'
import {useSelector} from 'react-redux'
import {useHistory} from 'react-router-dom'
import {Theme} from '../../../app/theme'
import {StringFacetPanel} from '../../../commons/components/facets/StringFacetPanel'
import {ResultDocument} from '../../../commons/types/SearchResult'
import {bookPathOverview, bookQueryParams} from '../../store/book.paths'
import {selectEbooks} from '../../store/book.selectors'
import {EBooksFilters} from '../../store/book.types'
import {EbookPanel} from './EbookPanel'

const renderEbookCol = (ebook: ResultDocument) => (
  <Col size={[12, 6]} key={ebook.id}>
    <EbookPanel ebook={ebook} />
  </Col>
)

export const EbooksPanel = () => {
  const ebooks = useSelector(selectEbooks)
  const history = useHistory()

  const filterReihe = useQueryParam(bookQueryParams.reihe)
  const filterRechtsstand = useQueryParam(bookQueryParams.rechtsstand)
  const userQuery = useQueryParam(bookQueryParams.userQuery)
  const filters: EBooksFilters = {reihe: filterReihe, rechtsstand: filterRechtsstand}

  if (!ebooks || !ebooks.documents) {
    if (ebooks?.documentsFound === 0) {
      return <Box>Es wurden keine Bücher gefunden.</Box>
    }
    return null
  }

  const performFiltering = (nextFilters: EBooksFilters) => {
    history.push(bookPathOverview(userQuery, nextFilters))
  }
  const facets = ebooks.facets

  return (
    <Flex fullWidth nowrap>
      <Box grow={1} fullWidth>
        <Grid>
          <ColRow>{ebooks.documents.map(renderEbookCol)}</ColRow>
        </Grid>
      </Box>
      <Box width={300} grow={0} shrink={0} display={['none', 'block']} px={2} pt={1}>
        <Box fullWidth>
          <Box<Theme> fontStyle="brandBold" fontSize="big" pb={2}>
            Suche verfeinern
          </Box>
          {facets && facets.reihe && (
            <StringFacetPanel<EBooksFilters>
              name="Reihen"
              currentFilter="reihe"
              values={facets.reihe}
              filters={filters}
              performFiltering={performFiltering}
            />
          )}
          {facets && facets.year && (
            <StringFacetPanel<EBooksFilters>
              name="Rechtsstand"
              currentFilter="rechtsstand"
              values={facets.year}
              filters={filters}
              performFiltering={performFiltering}
              reverse
            />
          )}
        </Box>
      </Box>
    </Flex>
  )
}
